<template>
  <img
    :data-src="src"
    :alt="alt"
    :class="imageClass"
  >
</template>

<script>
export default {
  name: 'VetsterPostCoverImage',

  props: {
    imageClass: {
      type: String,
      default: 'w-full object-cover aspect-',
    },
    post: {
      type: Object,
      required: true,
    },
  },

  computed: {
    alt() {
      return `${this.post.title} -  ${this.post.cover?.alt ?? 'Vetster'}`;
    },
    src() {
      return this.post.cover?.src
        || 'https://images.vetster.com/illustrations/vetster-white-logo-ocean-background.jpg';
    },
  },
};
</script>
